import { Link, useParams } from 'react-router-dom';
import { getPostBySlug, getAdjacentPosts, getRelatedPosts, getCategoryById } from '../data/blog';
import BlogHeader from '../components/BlogHeader';
import BlogFooter from '../components/BlogFooter';
import QuizCTA from '../components/QuizCTA';
import Breadcrumbs from '../components/Breadcrumbs';
import RelatedPosts from '../components/RelatedPosts';
import PostNavigation from '../components/PostNavigation';

export default function BlogPostPage() {
  const { slug } = useParams<{ slug: string }>();
  const post = slug ? getPostBySlug(slug) : undefined;

  if (!post) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center text-white">
        <h1 className="text-2xl font-bold mb-4">Post not found</h1>
        <Link to="/blog" className="text-primary hover:underline">
          ← Back to blog
        </Link>
      </div>
    );
  }

  const formattedDate = new Date(post.date).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  const category = getCategoryById(post.category);
  const { prev, next } = getAdjacentPosts(post.slug);
  const relatedPosts = getRelatedPosts(post.slug);

  return (
    <div className="min-h-screen flex flex-col text-white">
      <BlogHeader />

      <main className="pt-24 pb-20 px-6 max-w-2xl mx-auto w-full">
        <Breadcrumbs
          items={[
            { label: 'Home', href: '/' },
            { label: 'Blog', href: '/blog' },
            {
              label: category?.label ?? post.category.replace(/-/g, ' '),
              href: `/blog/category/${post.category}`,
            },
            { label: post.title },
          ]}
        />

        <article>
          <header className="mb-10">
            <div className="flex items-center gap-3 mb-4">
              <Link
                to={`/blog/category/${post.category}`}
                className="px-3 py-1 rounded-full bg-primary/10 text-primary text-xs font-bold border border-primary/20 capitalize hover:bg-primary/20 transition-colors"
              >
                {post.category.replace(/-/g, ' ')}
              </Link>
              <span className="text-slate-500 text-xs">{post.readingTime} min read</span>
            </div>

            <h1 className="text-3xl md:text-4xl font-extrabold leading-tight mb-4">
              {post.title}
            </h1>

            <p className="text-slate-400 text-lg mb-6">{post.description}</p>

            <div className="flex items-center gap-3 text-sm text-slate-500">
              <span>By OurSexQuiz</span>
              <span>·</span>
              <time dateTime={post.date}>{formattedDate}</time>
            </div>
          </header>

          <div
            className="blog-prose"
            dangerouslySetInnerHTML={{ __html: post.html }}
          />
        </article>

        <div className="mt-16">
          <QuizCTA />
        </div>

        {relatedPosts.length > 0 && (
          <div className="mt-16">
            <RelatedPosts posts={relatedPosts} />
          </div>
        )}

        <div className="mt-16">
          <PostNavigation prev={prev} next={next} />
        </div>
      </main>

      <BlogFooter />
    </div>
  );
}
